import { configureStore } from "@reduxjs/toolkit";
import browserDataSlice from "./browserdata-slice";
import productDataSlice from "./productdata-slice";
import hardwareDataSlice from "./hardwaredata-slice";

const store = configureStore({
  reducer: {
    browserData: browserDataSlice.reducer,
    productData: productDataSlice.reducer,
    hardwareData: hardwareDataSlice.reducer,
  },
});

export default store;
